/**
 * 클레임·진단점 화면에서 쓰는 코드/타입 문자열 파싱.
 * partnerAllList 페이징(상한)에 걸려도 클레임 스냅샷으로 UI를 복구할 때 사용.
 */

export function splitCommaList(value) {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) {
    return value.map((c) => String(c).trim()).filter(Boolean);
  }
  return String(value)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

/** partnerType 문자열 → 배열 (기존 el.partnerType.split(',') 대체) */
export function normalizePartnerType(value) {
  if (value == null || value === '') return '';
  if (Array.isArray(value)) return value;
  return String(value).split(',');
}

/** tbl_dt_claim_code type=R 등의 value 목록으로 라벨 문자열 생성 */
export function repairCodesToLabels(partnerAllType, rawCodes) {
  if (!partnerAllType?.length) return '';
  const codes = splitCommaList(rawCodes);
  if (!codes.length) return '';
  return partnerAllType
    .filter((item) =>
      codes.some((c) => String(c) === String(item.value))
    )
    .map((item) => item.label)
    .toString();
}
